<span class="comma-separated">
  <span
    *ngFor="let item of summary"
    class="{{ bodyClass }} regular-type ps-xxsmall-b"
    [class.grey-600-text]="item.type === ServiceType.NON_INCLUDED"
    [class.text-icon-disabled-text]="item.type === ServiceType.NON_INCLUDED"
  >
    <span *ngIf="item.text"
      ><span *ngIf="item.quantity">{{ item.quantity }} x </span>{{ item.text }}</span
    >
    <span *ngIf="item.description !== ''">{{ item.description | finLocalization: { amount: item.quantity } }}</span>
  </span>
</span>
